export default class Receipt {
    id?: number;
    fileName?: string;
    fileDate?: string;
    fileSize?: number;
    expenseRecordId?: number;
    s3Key?: string;
    base64ReceiptString?: string;
    base64InvoiceThumbnailString?: string;
    // Real billing code/description/amount for the expense line this receipt is attached to
    // (OFFICE_EXPENSE_UNIT or EXPENSE_SHEET, depending on DocumentSourceType).
    billingCode?: string;
    description?: string;
    amount?: number;
}


// WEBPACK FOOTER //
// ./src/components/project-billing/models/Receipt.ts